/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RoleDto } from '../models/role-dto';

@Injectable({
  providedIn: 'root',
})
export class GreybeeRoleRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getGreybeeRoleById
   */
  static readonly GetGreybeeRoleByIdPath = '/api/v1/greybeeRoleController/{id}';

  /**
   * Provides RoleDto based on the given Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGreybeeRoleById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGreybeeRoleById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RoleDto>> {

    const rb = new RequestBuilder(this.rootUrl, GreybeeRoleRestControllerService.GetGreybeeRoleByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleDto>;
      })
    );
  }

  /**
   * Provides RoleDto based on the given Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGreybeeRoleById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGreybeeRoleById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<RoleDto> {

    return this.getGreybeeRoleById$Response(params,context).pipe(
      map((r: StrictHttpResponse<RoleDto>) => r.body as RoleDto)
    );
  }

  /**
   * Path part for operation getGreybeeRoles
   */
  static readonly GetGreybeeRolesPath = '/api/v1/greybeeRoleController/all';

  /**
   * Provides the list of all GreybeeRoles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGreybeeRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGreybeeRoles$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<RoleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, GreybeeRoleRestControllerService.GetGreybeeRolesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleDto>>;
      })
    );
  }

  /**
   * Provides the list of all GreybeeRoles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGreybeeRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGreybeeRoles(params?: {
  },
  context?: HttpContext

): Observable<Array<RoleDto>> {

    return this.getGreybeeRoles$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<RoleDto>>) => r.body as Array<RoleDto>)
    );
  }

}
